import moment from "moment";
import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";

import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import {
  postRegattaForms,
  submitRegattaForms,
} from "../../redux/actions/regattaActions";

const MedicalQuestionnaireForm = ({
  appData,
  postRegattaFormsFunc,
  submitRegattaFormsFunc,
}) => {
  const { firstName = "", lastName = "", gender = "", address } = appData;

  const submitted = appData.regattaOnboarding && appData.regattaOnboarding.YREG;

  let initialData = {
    MedicalQuestionnaire2: `${firstName} ${lastName}`,
    MedicalQuestionnaire6: appData.dateOfBirth
      ? moment(appData.dateOfBirth).format("DD/MM/YYYY")
      : "",
    MedicalQuestionnaire8: gender,
    MedicalQuestionnaire11:
      address &&
      address.addressLine1 +
        (address.addressLine2 ? `, ${address.addressLine2}` : "") +
        (address.addressLine3 ? `, ${address.addressLine3}` : "") +
        (address.town ? `, ${address.town}` : "") +
        (address.county ? `, ${address.county}` : "") +
        (address.postcode ? `, ${address.postcode}` : ""),
    MedicalQuestionnaire42: `${firstName} ${lastName}`,
    MedicalQuestionnaire43: `${firstName} ${lastName}`,
    MedicalQuestionnaire46: `${firstName} ${lastName}`,
  };

  if (
    appData.regattaOnboarding &&
    appData.regattaOnboarding.MedicalQuestionnaire
  ) {
    initialData = {
      ...initialData,
      ...appData.regattaOnboarding.MedicalQuestionnaire,
    };
  }

  const getVal = getField(initialData);

  const initialState = {
    MedicalQuestionnaire1: {
      title: "",
      type: "heading",
      textDescription: [
        "To be completed by:",
        "1. All new employees",
        "2. MHE operators (whether permanent or agency) before being allowed to operate a vehicle",
        "3. Night shift workers every 12 months",
        "4. All employees driving on Company business ",
        "5. When deemed necessary as a result of an accident or incident investigation",
        "The Company is making Health & Safety assessments and decisions based on the information contained within this questionnaire. You have a duty to complete this questionnaire accurately and honestly, the Health, Safety and Welfare of employees is of paramount importance.",
        "Please note that failure to declare a known or suspected medical condition that may place your health, safety and wellbeing and that of others at risk could be regarded as a potential disciplinary offence and may lead to the termination of your contract.",
      ],
    },
    MedicalQuestionnaire2: {
      title: "Name",
      value: getVal("MedicalQuestionnaire2"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire3: {
      title: "Department",
      value: getVal("MedicalQuestionnaire3"),
      type: "text",
      mandatory: false,
    },
    MedicalQuestionnaire4: {
      title: "Manager",
      value: getVal("MedicalQuestionnaire4"),
      type: "text",
      mandatory: false,
    },
    MedicalQuestionnaire5: {
      title: "Job Role Description",
      value: getVal("MedicalQuestionnaire5"),
      type: "text",
      mandatory: false,
    },
    MedicalQuestionnaire6: {
      title: "Date of Birth",
      value: getVal("MedicalQuestionnaire6"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire7: {
      title: "Age",
      value: getVal("MedicalQuestionnaire7"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire8: {
      title: "Sex",
      value: getVal("MedicalQuestionnaire8"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire9: {
      title: "Site/Location",
      value: getVal("MedicalQuestionnaire9"),
      type: "text",
      mandatory: false,
    },
    MedicalQuestionnaire10: {
      title: "Shift",
      value: getVal("MedicalQuestionnaire10"),
      type: "text",
      mandatory: false,
    },
    MedicalQuestionnaire11: {
      title: "Home address",
      value: getVal("MedicalQuestionnaire11"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire12: {
      title: "Name and address of own doctor",
      value: getVal("MedicalQuestionnaire12"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire13: {
      title:
        "Please answer all of the following questions by selecting either Yes or No.",
      type: "heading",
      textDescription: [""],
    },
    MedicalQuestionnaire14: {
      title:
        "Do you have any physical or mental impairment that could be classed as a disability under the Equality Act 2010 or are you registered as disabled?",
      value: getVal("MedicalQuestionnaire14"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire15: {
      title: "If yes, please give details",
      value: getVal("MedicalQuestionnaire15"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire14",
        },
      ],
    },
    MedicalQuestionnaire16: {
      title: "Are there any medical reasons why you should not do shift work?",
      value: getVal("MedicalQuestionnaire16"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire17: {
      title: "If yes, please give details",
      value: getVal("MedicalQuestionnaire17"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire16",
        },
      ],
    },
    MedicalQuestionnaire18: {
      title:
        "Are there any medical conditions preventing you from undertaking any strenuous physical work including climbing ladders, bending, lifting and carrying? ",
      value: getVal("MedicalQuestionnaire18"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire19: {
      title: "If yes, please give details",
      value: getVal("MedicalQuestionnaire19"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire18",
        },
      ],
    },
    MedicalQuestionnaire20: {
      title:
        "Have you ever had to give up any previous employment for medical reasons?",
      value: getVal("MedicalQuestionnaire20"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire21: {
      title: "If yes, please give details",
      value: getVal("MedicalQuestionnaire21"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire20",
        },
      ],
    },
    MedicalQuestionnaire22: {
      title:
        "Have you been off work continuously for more than a month during the last five years due to medical reasons? ",
      value: getVal("MedicalQuestionnaire22"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire23: {
      title: "If yes, please give details",
      value: getVal("MedicalQuestionnaire23"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire22",
        },
      ],
    },
    MedicalQuestionnaire24: {
      title:
        "Have you ever had any operations requiring hospital admission for five or more days?",
      value: getVal("MedicalQuestionnaire24"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire25: {
      title: "If yes, please give details",
      value: getVal("MedicalQuestionnaire25"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire24",
        },
      ],
    },
    MedicalQuestionnaire26: {
      title:
        "Is your eyesight normal (with glasses / contact lenses etc. if worn)?",
      value: getVal("MedicalQuestionnaire26"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire27: {
      title: "If No, please give details",
      value: getVal("MedicalQuestionnaire27"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire26",
          allowedValues: [false],
        },
      ],
    },
    MedicalQuestionnaire28: {
      title: "Is your hearing normal?",
      value: getVal("MedicalQuestionnaire28"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire29: {
      title: "If No, please give details",
      value: getVal("MedicalQuestionnaire29"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire28",
          allowedValues: [false],
        },
      ],
    },
    MedicalQuestionnaire30: {
      title: "Do you regularly take or are currently taking any medications?",
      value: getVal("MedicalQuestionnaire30"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire31: {
      title:
        "If yes please provide name of the medication, what is the condition/reason for taking the medication, for how long have you been taking the medication and details of any side effects experienced",
      value: getVal("MedicalQuestionnaire31"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire30",
        },
      ],
    },
    MedicalQuestionnaire32: {
      title: "Have you ever had any of the following? ",
      value: getVal("MedicalQuestionnaire32"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Diabetes", value: "Diabetes" },
        { label: "Tuberculosis", value: "Tuberculosis" },
        { label: "Angina (heart trouble)", value: "Angina (heart trouble)" },
        { label: "Any other heart trouble", value: "Any other heart trouble" },
        {
          label: "Raised or low blood pressure",
          value: "Raised or low blood pressure",
        },
        {
          label: "Peptic, gastric or duodenal ulcer",
          value: "Peptic, gastric or duodenal ulcer",
        },
        {
          label: "Indigestion for more than one week",
          value: "Indigestion for more than one week",
        },
        {
          label:
            "Back trouble, lumbago, sciatica, ‘slipped disc’, Repetitive Strain Injuries (RSI)",
          value:
            "Back trouble, lumbago, sciatica, ‘slipped disc’, Repetitive Strain Injuries (RSI)",
        },
        {
          label:
            "Musculoskeletal problems (e.g. arthritis, pains in arms or legs, restricted movement)",
          value:
            "Musculoskeletal problems (e.g. arthritis, pains in arms or legs, restricted movement)",
        },
        {
          label: "Epilepsy, recurring blackout or fits",
          value: "Epilepsy, recurring blackout or fits",
        },
        {
          label: "Drug or alcohol problem including drug or alcohol dependency",
          value: "Drug or alcohol problem including drug or alcohol dependency",
        },
      ],
    },
    MedicalQuestionnaire33: {
      title:
        "Have you ever had any of the following during the past five years?",
      value: getVal("MedicalQuestionnaire33"),
      type: "multivalueCheckbox",
      selectOptions: [
        {
          label: "Bronchitis, asthma, pneumonia",
          value: "Bronchitis, asthma, pneumonia",
        },
        {
          label: "Dermatitis, eczema or any other skin trouble ",
          value: "Dermatitis, eczema or any other skin trouble ",
        },
      ],
    },
    MedicalQuestionnaire34: {
      title: "Do you suffer from any of the following? ",
      value: getVal("MedicalQuestionnaire34"),
      type: "multivalueCheckbox",
      selectOptions: [
        {
          label: "Migraine or severe recurring headaches",
          value: "Migraine or severe recurring headaches",
        },
        {
          label: "Anxiety, depression or any other nervous complaint",
          value: "Anxiety, depression or any other nervous complaint",
        },
        {
          label: "Fainting attacks or giddiness",
          value: "Fainting attacks or giddiness",
        },
        {
          label: "Tinnitus, ear trouble, discharging or infected ear",
          value: "Tinnitus, ear trouble, discharging or infected ear",
        },
        {
          label: "Kidney trouble or urinary infection ",
          value: "Kidney trouble or urinary infection ",
        },
        { label: "Dyslexia", value: "Dyslexia" },
        {
          label: "Vertigo, dizziness, problems with balance",
          value: "Vertigo, dizziness, problems with balance",
        },
        {
          label:
            "Allergies (including sensitivity to medicines, foods or any other substances such as Latex)",
          value:
            "Allergies (including sensitivity to medicines, foods or any other substances such as Latex)",
        },
      ],
    },
    MedicalQuestionnaire35: {
      title:
        "If you have have ticked any answers from the 3 lists above, please give brief details below:",
      value: getVal("MedicalQuestionnaire35"),
      type: "textarea",
      mandatory: false,
    },
    MedicalQuestionnaire36: {
      title: "Have you ever had any other serious illness/medical condition? ",
      value: getVal("MedicalQuestionnaire36"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire37: {
      title: "If yes, please give brief details below",
      value: getVal("MedicalQuestionnaire37"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire36",
        },
      ],
    },
    MedicalQuestionnaire38: {
      title:
        "Have you consulted a doctor about your health during the past 12 months or are you waiting for any hospital treatment or investigation? ",
      value: getVal("MedicalQuestionnaire38"),
      type: "checkbox",
      mandatory: true,
    },
    MedicalQuestionnaire39: {
      title: "If yes, please give brief details below",
      value: getVal("MedicalQuestionnaire39"),
      type: "textarea",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "MedicalQuestionnaire38",
        },
      ],
    },
    MedicalQuestionnaire40: {
      title: "Disclosure authority",
      type: "heading",
      textDescription: [
        "If you have a medical condition and there are grounds for concern regarding your safety and the potential impact on yourself or your colleagues due to the requirements of your job, a personal risk assessment may be required. In this case the information will be reviewed confidentially by the Health & Safety Officer and it will be securely stored by the Health & Safety department.",
        "If applicable and following consultation with you, your consent will be confirmed if the Health & Safety Officer believes it is necessary to share your personal medical information with our Occupational Health Specialist, HR or your Line Manager to ensure your health, safety and welfare whilst at work.",
      ],
    },
    MedicalQuestionnaire41: {
      title: "I agree to the disclosure authority above",
      value: getVal("MedicalQuestionnaire41"),
      type: "singlecheckbox",
      mandatory: true,
    },
    MedicalQuestionnaire42: {
      title: "Name",
      value: getVal("MedicalQuestionnaire42"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire43: {
      title: "Signature",
      value: getVal("MedicalQuestionnaire43"),
      type: "text",
      mandatory: true,
    },
    MedicalQuestionnaire44: {
      title: "Declaration",
      type: "heading",
      textDescription: [
        "I am willing to undergo a medical examination if required and I declare that the information I give on this questionnaire is correct to the best of my knowledge. ",
        "I agree that the Company may engage a doctor to consult my own doctor about any of the information given on this form. ",
      ],
    },
    MedicalQuestionnaire45: {
      title: "I agree to the declaration above",
      value: getVal("MedicalQuestionnaire45"),
      type: "singlecheckbox",
      mandatory: true,
    },
    MedicalQuestionnaire46: {
      title: "Signature",
      value: getVal("MedicalQuestionnaire46"),
      type: "text",
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const redirectBack = () => {
    history.push("/profile/edit/regatta-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postRegattaFormsFunc("MedicalQuestionnaire", {
      ...fieldValuesPayload,
    });

    redirectBack();
  };

  const submitForm = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postRegattaFormsFunc("MedicalQuestionnaire", {
      // save to JSON so that the medication upload can be shown if required tickbox is checked.
      ...fieldValuesPayload,
    });

    submitRegattaFormsFunc(
      "MedicalQuestionnaire",
      {
        ...fieldValuesPayload,
      },
      "YREG"
    );

    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Medical Questionnaire"}
          fields={fields}
          setField={setField}
          handleSubmit={handleSubmit} // handles save to JSON
          handleCancel={() => redirectBack()}
          onboardingBranch={"Regatta"}
          submitSingleForm={true}
          handleSingleSubmit={submitForm} // Submits to PDF
        />
      )}
    </>
  );
};

MedicalQuestionnaireForm.propTypes = {
  appData: any,
  postRegattaFormsFunc: func.isRequired,
  submitRegattaFormsFunc: func.isRequired,
};

const mapDispatchToProps = {
  postRegattaFormsFunc: postRegattaForms,
  submitRegattaFormsFunc: submitRegattaForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(MedicalQuestionnaireForm);
